import { useContext } from 'react';
import GlobalContext from '../../../contexts';

const inviteCustomersFields = (organizationId) => {
  const { productsList } = useContext(GlobalContext);

  return [
    {
      name: 'productId',
      label: 'בחר מוצר',
      required: true,
      type: 'select',
      options:
        productsList
          ?.filter(
            (product) => product?.organizationId === Number(organizationId)
          )
          .map((product) => ({
            id: product.id,
            name: product.name
          })) || [],
      breakLine: true
    },
    {
      name: 'emails',
      label: 'רשימת מיילים (מייל אחד בכל שורה)',
      required: true,
      type: 'simple-textarea',
      rows: 3,
      validate: (value) => {
        const emails = value
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line.length > 0);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const allValid = emails.every((email) => emailRegex.test(email));
        return allValid || 'יש להזין כתובת אימייל אחת תקינה בכל שורה';
      }
    }
  ];
};

export default inviteCustomersFields;
